import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { passwordResetAPI } from '../../services/api';
import { Link, useNavigate } from 'react-router-dom';
import { CornerDownLeft } from 'lucide-react';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async ({ email }) => {
    try {
      const res = await passwordResetAPI.request(email);
      toast.success(res.data?.message || 'If the email exists, a reset code has been sent');
      navigate('/reset-password', { state: { email } });
    } catch (error) {
      toast.success('If the email exists, a reset code has been sent');
      navigate('/reset-password', { state: { email } });
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">Forgot Password</h2>
          <p className="mt-2 text-center italic text-sm text-gray-600">
            We'll send a code to your email
          </p>
        </div>
        <div className='px-5 pb-5 rounded-3xl border drop-shadow-lg'>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
            <div>
              <label className="form-label" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                className={`pl-4  form-input ${errors.email ? 'border-red-500' : ''}`}
                placeholder="you@example.com"
                {...register('email', { required: 'Email is required' })}
              />
              {errors.email && (
                <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
              )}
            </div>
            <button type="submit" className="btn-primary w-full">Send Code</button>
            
          </form>
        </div>
        <div className="text-center flex justify-center align-center drop-shadow-lg">
              <Link to="/login">
                <CornerDownLeft color='black' size={40}/>
              </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;


